import { ID, Identifiable, Optional } from './types'

export function removeEntityById<T extends Identifiable>(entities: Optional<T[]>, id: ID) {
	return (entities ?? []).filter((entity) => id !== entity.id)
}
